import { styled } from '@mui/system';
import { NuvoText } from '@nuvolo/nuux-core/components/NuvoText';
import { color } from '@nuvolo/nuux-theme/utils';
import { borderRadius } from '#/common/hooks/useClientTheme';
import { hexOpacity } from '#/common/utils/hexOpacity';

export const CardWrapper = styled('div')<{ selected?: boolean; hasIcon?: boolean }>(
  ({ selected, hasIcon = true }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: hasIcon ? '12px' : '8px',
    padding: hasIcon ? '12px' : '8px',
    borderRadius: borderRadius?.s || '16px',
    backgroundColor: selected ? color('custom', 'focusItemBackground') : 'transparent',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    minHeight: hasIcon ? '72px' : '52px',

    '&:hover': {
      backgroundColor: selected
        ? color('custom', 'focusItemBackground')
        : color('custom', 'focusItemBackground'),
    },

    ...(!selected && {
      '&:hover .checkmark-wrapper': {
        opacity: 0.5,
      },
    }),
  }),
);

export const IconWrapper = styled('div')<{
  selected?: boolean;
  iconColor?: string;
  iconHolderColor?: string;
}>(({ selected, iconColor, iconHolderColor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '36px',
  height: '36px',
  borderRadius: '12px',
  backgroundColor:
    iconHolderColor ||
    (selected
      ? hexOpacity(color('primary', 'dark'), 0.6)
      : hexOpacity(color('secondary', 'dark2'), 0.6)),
  color: iconColor || (selected ? color('primary', 'dark') : color('secondary', 'dark2')),
}));

export const ContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
  minWidth: 0,
});

export const Title = styled(NuvoText)<{ selected?: boolean }>(({ selected }) => ({
  fontWeight: '600',
  fontSize: '14px',
  color: color('custom', 'contrastText'),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const Subtitle = styled(NuvoText)<{ selected?: boolean }>(({ selected }) => ({
  fontSize: '12px',
  color: selected ? color('secondary', 'dark2') : color('secondary', 'light'),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  transition: 'all 0.2s ease',
}));

export const CheckmarkWrapper = styled('div')<{ selected?: boolean }>(({ selected }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  marginLeft: '12px',
  color: color('primary', 'dark'),
  opacity: selected ? 1 : 0,
  transition: 'opacity 0.2s ease',
}));
